'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CharacterCount = require('./components/CharacterCount.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CharacterCount).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-character-count/lib/index.js
// module id = 518
// module chunks = 1